import React from 'react';
import styles from './CardBlock.module.css';
import cardIcon from './CardIcons';
import { FaCheck, FaApple } from "react-icons/fa";
import { FaCreditCard } from "react-icons/fa6";



function CardBlock({ key, type, number, expiry, selected, id, onClick, loading, wallet }) {
    console.log("Wallet in card block", wallet);
    return (
        <div className={`${ styles['card-block']} ${selected ? styles['selected'] : ''} ${loading ? styles['loading'] : ''}`} 
            //  style={wallet?.type === 'apple_pay' ? { background: 'black', color: 'white' } : {}}
             onClick={() => { onClick && onClick(id ? id : null) }}>

            <div className={wallet?.type === 'apple_pay' ? styles['card-left-apple-pay'] : styles['card-left']}>
                <div className={styles['item']}>
                    {loading ? <>
                        <div className={`card-text placeholder-glow`}>
                            <span className="placeholder col-12" style={{ borderRadius: '61px', width: '70px' }}></span>
                        </div>
                        <div className={`card-text placeholder-glow`}>
                            <span className="placeholder col-12" style={{ borderRadius: '10px', width: '170px' }}></span>
                        </div>
                    </>
                        :
                        <>
                            {
                                wallet?.type === 'apple_pay' ?
                                    <><div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                                        <span style={{ fontSize: '16px', fontWeight: '600' }}><FaApple size={25} /> Pay</span>
                                    </div>
                                     <div>XXXX XXXX XXXX {number}</div></>
                                    :
                                    <>
                                        <span>CARD NUMBER</span>
                                        <div>XXXX XXXX XXXX {number}</div>
                                        {/* {wallet !== null && <div>WALLET: {wallet.type}</div>} */}
                                    </>
                            }

                        </>
                    }
                </div>
                {selected ? <div className={styles['exp-date']}>
                    <div>{expiry}</div>
                </div> : <></>}
            </div>
            {selected && <div className={styles['selected-badge']}><FaCheck /></div>}
            <div className={styles['card-right']}>
                {loading ?
                    <>
                        <p style={{ width: '120%' }} className={`card-text placeholder-glow`}>
                            <span className="placeholder col-12" style={{ borderRadius: '10px', height: '27px', width: '80px' }}></span>
                        </p>

                    </>
                    :
                    <>
                        {
                            // wallet?.type === 'apple_pay' ?
                            //     <div className={styles['unknown-card']}>
                            //         <FaApple style={{ color: 'black' }} size={30} />
                            //     </div>
                            //     :
                                <>
                                    {cardIcon[type]
                                        ?
                                        <img className={styles['card-icon']} src={cardIcon[type]} alt={`card`} />
                                        :
                                        <div className={styles['unknown-card']}>
                                            <FaCreditCard />
                                        </div>
                                    }
                                </>
                        }
                    </>
                }

            </div>
        </div>
    );
}

export default CardBlock;
